import React, { useState } from "react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";
import { Button } from "../ui/button";

const FIELDS = [
  { key: "title", label: "Project title", required: true, max: 160 },
  { key: "category", label: "Category (e.g. Kitchen remodel)", max: 80 },
  { key: "address_city", label: "City", max: 80 },
  { key: "address_state", label: "State", max: 40 },
  { key: "start_date", label: "Start date", type: "date" },
  { key: "end_date", label: "Completion date", type: "date" },
];

export function ProjectForm({ initial = {}, onSubmit, submitLabel = "Save", busy, disabled }) {
  const [v, setV] = useState({
    title: "", summary: "", long_description: "", category: "", address_city: "",
    address_state: "", start_date: "", end_date: "", ...initial,
  });
  const set = (k) => (e) => setV((s) => ({ ...s, [k]: e.target.value }));
  const submit = (e) => {
    e.preventDefault();
    const out = {};
    Object.keys(v).forEach((k) => {
      if (FIELDS.some((f) => f.key === k) || ["summary", "long_description"].includes(k)) {
        if (k.endsWith("_date")) { if (v[k]) out[k] = v[k]; } else out[k] = v[k] ?? "";
      }
    });
    onSubmit(out);
  };
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="portfolio-project-form">
      <div className="grid gap-4 sm:grid-cols-2">
        {FIELDS.map((f) => (
          <div key={f.key} className={f.key === "title" ? "sm:col-span-2" : ""}>
            <Label htmlFor={`pf-${f.key}`} className="font-nav text-erf-dark">{f.label}{f.required && " *"}</Label>
            <Input id={`pf-${f.key}`} type={f.type || "text"} value={v[f.key] || ""} onChange={set(f.key)}
              required={f.required} maxLength={f.max} disabled={disabled}
              className="mt-1 min-h-[44px] bg-white text-erf-dark" data-testid={`portfolio-field-${f.key}`} />
          </div>
        ))}
      </div>
      <div>
        <Label htmlFor="pf-summary" className="font-nav text-erf-dark">Summary (shown on the public card)</Label>
        <Textarea id="pf-summary" value={v.summary || ""} onChange={set("summary")} maxLength={600} disabled={disabled}
          className="mt-1 bg-white text-erf-dark" rows={3} data-testid="portfolio-field-summary" />
      </div>
      <div>
        <Label htmlFor="pf-long" className="font-nav text-erf-dark">Full description</Label>
        <Textarea id="pf-long" value={v.long_description || ""} onChange={set("long_description")} maxLength={8000}
          disabled={disabled} className="mt-1 bg-white text-erf-dark" rows={6} data-testid="portfolio-field-long_description" />
      </div>
      {!disabled && (
        <Button type="submit" disabled={busy || !v.title?.trim()} className="bg-erf-gold text-erf-dark hover:bg-erf-goldHover"
          data-testid="portfolio-project-submit">
          {busy ? "Saving…" : submitLabel}
        </Button>
      )}
    </form>
  );
}
